import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Typography,
  Paper
} from "@mui/material";
import { JiraIssue } from "axiosApi/models";
import JiraIssueRow from "./JiraIssueRow";
import JiraIssuesListPagination from ".//JiraIssuesListPagination";
import Spinner from "../../Spinner";
import intl from "components/i18n/ReactIntlWrapper";

export type JiraIssuesListProps = {
  jiraIssues: JiraIssue[];
  handleIssuesAdd: Function;
  handleIssueSelect: Function;
  handleIssueSelectAll: Function;
  isIssueSelected: Function;
  isIssueSelectedAll: Function;
  setPageNum: Function;
  pageNum: number;
  pageSize: number;
  totalRecords: number;
  loading: boolean;
};

const JiraIssuesList = ({
  jiraIssues,
  handleIssuesAdd,
  handleIssueSelect,
  handleIssueSelectAll,
  isIssueSelected,
  isIssueSelectedAll,
  setPageNum,
  pageNum,
  pageSize,
  totalRecords,
  loading
}: JiraIssuesListProps) => {
  const showSpinner = loading || !jiraIssues;

  return (
    <>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox">
                <Checkbox
                  checked={isIssueSelectedAll()}
                  onChange={(e) => handleIssueSelectAll(e.target.checked)}
                />
              </TableCell>
              <TableCell>{intl.get("jiraIssuesList.table.thead.issue")}</TableCell>
              <TableCell>{intl.get("jiraIssuesList.table.thead.summary")}</TableCell>
              <TableCell>{intl.get("jiraIssuesList.table.thead.jira")}</TableCell>
              <TableCell align="center">
                {intl.get("jiraIssuesList.table.thead.actions")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {showSpinner ? (
              <TableRow>
                <TableCell colSpan={5}>
                  <Spinner />
                </TableCell>
              </TableRow>
            ) : jiraIssues.map((issue) => (
              <JiraIssueRow
                key={issue.idJira}
                jiraKey={issue.key}
                idJira={issue.idJira}
                summary={issue.summary}
                handleIssueAdd={handleIssuesAdd}
                handleIssueSelect={handleIssueSelect}
                isIssueSelected={isIssueSelected}
              />
            ))}
            {!showSpinner && totalRecords === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography fontWeight="bold">
                    {intl.get("jiraIssuesList.noResults")}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
            {!showSpinner && totalRecords > 0 && jiraIssues.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography fontWeight="bold">
                    {intl.get("jiraIssuesList.alreadyAdded")}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <JiraIssuesListPagination
        setPageNum={setPageNum}
        pageNum={pageNum}
        pageSize={pageSize}
        totalRecords={totalRecords}
      />
    </>
  );
};

export default JiraIssuesList;